export const name = 'fb';

export const FB = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 12.5673C23 6.45512 18.075 1.5 12 1.5C5.92499 1.5 1 6.45512 1 12.5673C1 18.0913 5.02268 22.6698 10.281 23.5V15.7662H7.48789V12.5673H10.281V10.1289C10.281 7.35506 11.9235 5.82323 14.4357 5.82323C15.6393 5.82323 16.8979 6.03911 16.8979 6.03911V8.76258H15.511C14.1445 8.76258 13.7184 9.61583 13.7184 10.4909V12.5667H16.7695L16.2819 15.7656H13.719V23.4994C18.9773 22.6698 23 18.0913 23 12.5673Z"
      fill="currentColor"
    />
  </svg>
);
